import React, { PureComponent } from 'react';
import T from 'prop-types';
// hoc
import withSizes from 'react-sizes';
// components
import FieldError from '../../../components/Form/FieldError';
import Icon from '../../../components/Icon/Icon';
// utils
import isEmpty from 'lodash.isempty';
// shapes
import fixedInput from '../../../shapes/fixedInput';
// styles
import styles from './RadioTable.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

class RadioTable extends PureComponent {
  getScoreFromValues = () => {
    const {
      values,
      data: {
        content: { questions }
      }
    } = this.props;

    let score = 0;

    questions.forEach(({ id, question_answers }) => {
      question_answers.forEach(item => {
        if (values[id] === item.id) score += parseInt(item.additional_info, 10);
      });
    });

    return score;
  };

  answersRenderer = () => {
    const {
      data: { content }
    } = this.props;

    const score = this.getScoreFromValues();
    let message = '';

    content.question_results.forEach(item => {
      const range = item.result_conditions.split(' - ');
      const isInRange =
        parseInt(range[0], 10) <= score && score <= parseInt(range[1], 10);

      if (isInRange) {
        message = item.result_text;
      }
    });

    return message ? <div className={cx('message')}>{message}</div> : null;
  };

  render() {
    const {
      className = '',
      setFieldValue,
      isMobile,
      isDesktop,
      values,
      errors = {},
      data: {
        content: { questions, question_results }
      }
    } = this.props;

    const hasError =
      !isEmpty(errors) &&
      !!questions.find(({ id }) => errors.hasOwnProperty(id));
    const error = hasError ? 'All fields must be selected!' : '';

    if (isDesktop) {
      return (
        <div className={cx('container', className)}>
          <div className={cx('row', 'header-row')}>
            <div className={cx('title-cell')} />
            {questions[0].question_answers.map(({ title }, index) => (
              <div className={cx('cell')} key={index}>
                {title}
              </div>
            ))}
          </div>
          {questions.map(({ title, description, id }, index) => (
            <div
              key={id}
              className={cx('row', {
                error: errors.hasOwnProperty(id)
              })}
            >
              <div key={id} className={cx('title-cell')}>
                {title}
                {description && (
                  <span
                    data-hint={description}
                    className={cx('help-wrapper', 'hint--top')}
                  >
                    <Icon className={cx('icon-help')} type="help" />
                  </span>
                )}
              </div>
              {questions[index].question_answers.map((answer, index) => (
                <label key={index} className={cx('label')}>
                  <input
                    name={id}
                    type="radio"
                    checked={values[id] === answer.id}
                    onChange={() => setFieldValue(id, answer.id)}
                    value={answer.id}
                    className={cx('input')}
                  />
                  <span className={cx('circle')} />
                </label>
              ))}
            </div>
          ))}
          <FieldError error={error} touched={true} />
          {question_results && this.answersRenderer()}
        </div>
      );
    }

    if (isMobile) {
      return (
        <div className={cx('mob-container', className)}>
          {questions.map(({ title, description, id }, index) => (
            <div
              key={id}
              className={cx('column', {
                error: errors.hasOwnProperty(id)
              })}
            >
              <div key={id} className={cx('title-cell')}>
                {title}
                {description && (
                  <span
                    data-hint={description}
                    className={cx('help-wrapper', 'hint--top')}
                  >
                    <Icon className={cx('icon-help')} type="help" />
                  </span>
                )}
              </div>
              {questions[index].question_answers.map((answer, index) => (
                <label key={index} className={cx('mob-row')}>
                  <span className={cx('answer')}>{answer.title}</span>
                  <input
                    name={id}
                    type="radio"
                    defaultChecked={values[id] === answer.id}
                    onChange={() => setFieldValue(id, answer.id)}
                    value={answer.id}
                    className={cx('input')}
                  />
                  <span className={cx('circle')} />
                </label>
              ))}
            </div>
          ))}
          <FieldError error={error} touched={true} />
          {question_results && this.answersRenderer()}
        </div>
      );
    }
  }
}

RadioTable.propTypes = {
  className: T.string,
  setFieldValue: T.func.isRequired,
  isMobile: T.bool.isRequired,
  isDesktop: T.bool.isRequired,
  values: T.object.isRequired,
  data: fixedInput
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
  isDesktop: width >= 768
});

export default withSizes(mapSizesToProps)(RadioTable);



// WEBPACK FOOTER //
// ./src/containers/Module/components/RadioTable.jsx